import i18next from "i18next";


export const LANG_CODE = ['en','zh'] as const
export type LangCode = typeof LANG_CODE[number]
export const langLabel = {
  en: "English",
  zh: "中文"
}

const language = localStorage.getItem('i18nextLng') as LangCode || i18next.language

export const changeLanguage = (newLang: LangCode) =>{
  localStorage.setItem('i18nextLng', newLang)
  i18next.changeLanguage(newLang)

}

export default language

